import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Text } from "@jsq/ds/core";
import { PaymentInstructionStatus } from "../cellStatus/PaymentInstructionStatus";
import { PositionData } from "../types";
import { cellText } from "./styles_vanilla.css";

interface PaymentInstructionCellRendererProps extends ICellRendererParams {
  data: PositionData;
}

const PaymentInstructionCellRenderer: React.FC<PaymentInstructionCellRendererProps> = ({
  data,
}) => {
  if (!data) return null;

  const isGroupRow = data.successorCases && data.successorCases.length > 0;

  if (isGroupRow) {
    return <Text className={cellText}></Text>;
  }

  if (!data.currentBankName && !data.redactedBankAccountNumber) {
    return <Text className={cellText}>--</Text>;
  }

  return (
    <PaymentInstructionStatus
      bankName={data.currentBankName || ""}
      bankAccount={data.redactedBankAccountNumber || ""}
      disabled={false}
    />
  );
};

export default PaymentInstructionCellRenderer;
